module.exports = "/_next/static/images/video_id_7186063967695949102-c43e8419cdec7bcb9b1c078bb5f582e0.jpg";